import { defineStore } from 'pinia';
import { customStorage } from '../utils';
const createInitialState = () => ({
    entryModelCode: '',
    selectedGenerationCode: '',
    committedGenerationCode: '',
    fromVersionSelect: false,
    versionBackTipGloballyShown: false,
});
export const useNewFlowSessionStore = defineStore('new-flow-session', {
    state: createInitialState,
    getters: {
        hasCommittedSession(state) {
            return Boolean(state.entryModelCode && state.committedGenerationCode);
        },
        /** 是否已在任一进新流程会话中展示过「返回版本页」提示（全局，不按车型） */
        hasShownVersionBackTip(state) {
            return Boolean(state.versionBackTipGloballyShown);
        },
    },
    actions: {
        prepareVersionSelectSession(modelCode, generationCode) {
            this.entryModelCode = modelCode;
            this.selectedGenerationCode = generationCode;
            this.fromVersionSelect = true;
        },
        updateSelectedGenerationCode(generationCode) {
            this.selectedGenerationCode = generationCode;
        },
        commitSelectedGenerationCode(generationCode) {
            const nextGenerationCode = generationCode ?? this.selectedGenerationCode;
            if (!nextGenerationCode)
                return;
            this.committedGenerationCode = nextGenerationCode;
            this.fromVersionSelect = true;
        },
        commitVersionSelectSession(modelCode, generationCode) {
            this.prepareVersionSelectSession(modelCode, generationCode);
            this.commitSelectedGenerationCode(generationCode);
        },
        markVersionSelectSource(value) {
            this.fromVersionSelect = value;
        },
        markVersionBackTipShown() {
            this.versionBackTipGloballyShown = true;
        },
    },
    persist: {
        enabled: !!window && !!window.sessionStorage,
        strategies: [
            {
                storage: customStorage,
            },
        ],
    },
});
